import React, { useState, useEffect } from 'react';
import useIntersectionObserver from '../hooks/useIntersectionObserver';
import { classNames } from '../utils/utils';

// This will load the image in the background
const loadImage = (src, setIsLoaded) => {
  const image = new window.Image();

  image.onload = () => setIsLoaded(true);

  image.src = src;
};

const LazyLoadImage = ({ placeholder, src, alt, className }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [rootRef, isIntersecting] = useIntersectionObserver();

  useEffect(() => {
    if (!isLoading && isIntersecting) {
      setIsLoading(true);
      loadImage(src, setIsLoaded);
    }
  }, [isLoading, isIntersecting, src])

  if (isLoaded) {
    return <img ref={rootRef} className={classNames(className, 'blur-none transition-all will-change-[filter]')} src={src} alt={alt} style={{ transform: "translateZ(0)" }} />;
  }
    
  return (
    <img
      ref={rootRef}
      className={classNames(className, 'blur-lg transition-all will-change-[filter]')}
      src={placeholder}
      alt={alt}
    />
  );
};

export default LazyLoadImage;
